<template lang="pug">
v-dialog(
  v-model="popupDialog"
  transition="dialog-bottom-transition"
  width="800"
)
  v-card
    v-toolbar(dense flat color="accent white--text")
      v-fade-transition(mode="out-in")
        v-toolbar-title() Add Section
      v-spacer
      v-btn(icon @click.native="popupDialog = false")
        v-icon close
    v-form(ref="form" v-model="valid")
      v-container
        v-layout(row wrap)
          v-flex(xs12 sm12 md11 flex-1)
            span() Section Name
        v-layout(row wrap)
          v-flex(xs12 sm12 md11 flex-1 sectionNameBox)
            v-text-field(
              v-model="title"
              outline
              single-line
              label="Enter section name here"
              :rules="[rules.titleRequired]"
              required
              :maxlength="max"
            )
        v-layout(row wrap)
          v-flex(xs12 sm12 md11 flex-1)
            span() {{sectionNumberText}}
        v-layout(row wrap)
          v-flex(xs12 sm12 md12 flex-full sectionNumBox)
            v-autocomplete(
              :rules="[rules.NumberRequired]"
              required
              v-model="selectNumber"
              :items="Numbers"
              placeholder="Section number here"
            )
              template(slot="selection" slot-scope="data")
                span() {{data.item.number}}
              <template slot="item" slot-scope="data">
                  span().numberSelect {{data.item.number}}
              </template>
        v-layout(row wrap checkboxAdmin v-if="isAllowedTo(4)")
          v-flex(xs12 sm12 md11 flex-1)
            v-checkbox(
            v-model="allowSiteAdmin"
            :label="`Allow Site Administrator to Edit this Section`")
        v-layout(row wrap)
          v-flex(xs12 sm12 md11 flex-1)
            v-btn(
            flat
            @click.native="createSection"
            id="createSectionBtn"
            ).button-add-section Save
            v-btn(flat @click.native="popupDialog = false").button-close Close
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Base from '@/components/views/Base';
import { section } from '@/api';

export default {
    name: 'AddSectionModuleDialog',
    extends: Base,
    props: {
        showDialog: { type: Boolean, default: false },
        list: { type: Array, default: () => { return []; } },
        organisation: { type: String, required: true },
    },

    data() {
        return {
            valid: false,
            popupDialog: false,
            title: '',
            allowSiteAdmin: false,
            editRole: this.role,
            selectNumber: null,
            Numbers: [],
            rules: {
                titleRequired: value => !!value || 'Section name is Required.',
                NumberRequired: value => !!value || 'Section placement is Required.',
            },
            sectionNumberText: 'Section placement (Enter number from drop down of order you wish this section to appear)',
            max: 120,
            sectionLists: [],
            createdSection: {}
        };
    },
    created() {
        this.setLoading(true);
    },
    watch: {
        showDialog(value) {
            if (value) {
                this.popupDialog = true;
            }
        },

        popupDialog(value) {
            if (!value) {
                this.$emit('closed');
            }
        },
    },

    computed: {
        ...mapState({
            subdomain: state => state.session.subdomain,
            role: state => state.session.role,
            siteType: state => state.session.siteType,
        }),
        ...mapGetters({
            isAllowedTo: 'session/isAllowedTo'
        }),
    },

    methods: {
        runFormValidation() {
            this.$refs.form.validate();
        },
        getRole() {
            let adminType;
            switch (this.siteType) {
                case (1):
                case (2):
                    adminType = '2';
                    break;
                case (3):
                    adminType = '3';
                    break;
                default:
                    adminType = '4';
                    break;
            }
            return adminType;
        },
        async createSection() {
            this.runFormValidation();
            if (this.title === '' || this.title === null || this.selectNumber === null) {
                return;
            }
            try {
                this.setLoading(true);
                this.editRole = (this.allowSiteAdmin) ?
                    parseInt(this.getRole(), 10) :
                    parseInt(this.role, 10);

                const sectionItem = {
                    title: this.title,
                    organisation: this.organisation,
                    hidden: false,
                    priority: this.selectNumber.number,
                    editrole: this.editRole,
                    created_at: new Date(),
                    updated_at: new Date()
                };
                const response = await section.create(sectionItem);
                if (response) {
                    this.createdSection = response.data;
                    response.data.isChange = true;
                }
                this.$emit('reloadSection', this.createdSection);
                this.showSuccessAlert('Success.');
            } catch (err) {
                this.showErrorAlert(err.message);
            } finally {
                this.setLoading(false);
                this.allowSiteAdmin = false;
                this.popupDialog = false;
            }
        },

        LoadCreateSection() {
            this.title = '';
            this.Numbers = [];
            this.selectNumber = null;
            const enableSections = this.list.filter(item => !item.hidden);
            for (let i = 0; i < enableSections.length; i++) {
                this.Numbers.push({ id: enableSections[i].id, number: i + 1 });
            }
            this.Numbers.push({ id: 0, number: enableSections.length + 1 });
        },
    }
};
</script>
<style scoped>
.button-add-section {
  float:right;
  font-weight:bold;
  background-color: var(--v-secondary-base);
  color: white;
}
.button-close {
  color: var(--v-secondary-base);
  border:1px solid var(--v-secondary-base);
}
.primary--text{
  color: black !important;
  caret-color: black !important;
}
.numberSelect{
  color: black !important;
}
</style>
<style>
.sectionNameBox .v-text-field--outline > .v-input__control > .v-input__slot{
  min-height:initial;
  height:40px;
}
.sectionNameBox .v-text-field--outline .v-label{
  top:8px;
}
.sectionNameBox .v-text-field--outline > .v-input__control > .v-input__slot input{
  margin:3px 0;
}
.sectionNumBox .v-input__slot{
  max-width:320px;
  border: 2px solid rgba(0,0,0,0.54);
  border-radius:4px;
  padding-left:12px;
}
i.primary--text {
  color: black !important;
}
.checkboxAdmin label{
  font-size:14px;
  color: #000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/dashboard/AddSectionModuleDialog.vue